import { createPropStyling } from "../privatePropStylingUtils";
export const transformCssAttrNames = ["opacity", "transform"];
export const transformPropStyling = createPropStyling(transformCssAttrNames);
//# sourceMappingURL=transformPropStyling.js.map